export const officerItems: {
  title: string
  name: string
  profile: {
    date: string
    content: string | JSX.Element
  }[]
}[] = [
  {
    title: 'Representative Director and President',
    name: 'Hiro Nagata',
    profile: [
      {
        date: 'Aug. 2009',
        content: 'Joined TRIAL Company, Inc.',
      },
      {
        date: 'May 2012',
        content: 'Executive Manager of Corporate Planning Department of Trial Retail Engineering, Inc.',
      },
      {
        date: 'Nov. 2018',
        content: 'Representative Director and CEO of Retail AI, Inc.',
      },
      {
        date: 'Sep. 2020',
        content: 'Director of TRIAL Holdings, Inc. (current position)',
      },
      {
        date: 'Oct. 2021',
        content: 'Executive Manager of Company Communication of TRIAL Holdings, Inc.',
      },
      {
        date: 'Apr. 2025',
        content: 'Representative Director and President of TRIAL Holdings, Inc. (current position)',
      },
      {
        date: 'Apr. 2026',
        content: 'Representative Director and President of TRIAL Company, Inc. (current position)',
      },
    ],
  },
  {
    title: 'Director',
    name: 'Ryota Ishibashi',
    profile: [
      {
        date: 'Jan. 1999',
        content: 'Joined TRE, Inc.',
      },
      {
        date: 'Jul. 1999',
        content: 'Joined TRIAL Company, Inc.',
      },
      {
        date: 'Aug. 2004',
        content: 'Chairman of YANTAI TRIAL RETAILING ENGINEERING CO., LTD.',
      },
      {
        date: 'Aug. 2011',
        content: 'Executive Manager of Small Format Business Division, Sales Headquarters, TRIAL Company, Inc.',
      },
      {
        date: 'Jun. 2015',
        content: 'Director & General Manager of TCM, Product Headquarters, TRIAL Company, Inc.',
      },
      {
        date: 'Dec. 2016',
        content: 'Executive Vice President of TRIAL Company, Inc.',
      },
      {
        date: 'Jun. 2018',
        content: (
          <>
            Representative Director and President of TRIAL Company, Inc.
            <br />
            Director of TRIAL Holdings, Inc. (current position)
          </>
        ),
      },
      {
        date: 'Apr. 2026',
        content: 'Representative Director and President of TRIAL Technology, Inc. (current position)',
      },
    ],
  },

  {
    title: 'Outside Director',
    name: 'Hirofumi Tatsumoto',
    profile: [
      {
        date: 'Oct. 2002',
        content: 'Assistant for Research Center for Advanced Science and Technology, The University of Tokyo',
      },
      {
        date: 'Apr. 2004',
        content: 'Assistant Professor for Manufacturing Management Research Center, The University of Tokyo',
      },
      {
        date: 'Apr. 2009',
        content: 'Associate Professor for School of Business Administration, University of Hyogo',
      },
      {
        date: 'Sep. 2010',
        content: 'Visiting Researcher at MIT (Sloan School of Management)',
      },
      {
        date: 'Oct. 2012',
        content: 'Associate Professor for Faculty of Business Sciences, Tsukuba University',
      },
      {
        date: 'Apr. 2016',
        content: 'Professor for Faculty of Business Sciences, Tsukuba University (current position)',
      },
      {
        date: 'Jan. 2019',
        content: 'Outside Director of Retail AI, Inc.',
      },
      {
        date: 'Sep. 2020',
        content: 'Director of TRIAL Holdings, Inc. (current position)',
      },
      {
        date: 'Apr. 2026',
        content: 'Outside Director of TRIAL Technology, Inc. (current position)',
      },
    ],
  },
  {
    title: 'Outside Director',
    name: 'Chang Sangsoo',
    profile: [
      {
        date: 'Jun. 1981',
        content: 'Joined Korea Institute for Industrial Economics and Trade',
      },
      {
        date: 'Jun. 1991',
        content: 'Joined Samsung Economic Research Institute',
      },
      {
        date: 'Apr. 2013',
        content: 'Specially Appointed Professor of Faculty of Business Administration, Asia University',
      },
      {
        date: 'Apr. 2016',
        content: 'Full-Time Professor of Faculty of Urban Innovation, Asia University',
      },
      {
        date: 'Sep. 2022',
        content: 'Outside Director of TRIAL Holdings, Inc. (current position)',
      },
    ],
  },
  {
    title: 'Standing Corporate Auditor',
    name: 'Takeshi Agari',
    profile: [
      {
        date: 'Apr. 1996',
        content: 'Joined The Bank of Fukuoka, Ltd.',
      },
      {
        date: 'Dec. 2018',
        content:
          'Deputy Manager, Finance Department, Finance & Accounting Headquarters of TRIAL Shared Service, Inc.',
      },
      {
        date: 'Mar. 2019',
        content: 'Senior Executive Vice President of TRIAL Estate Development, Inc.',
      },
      {
        date: 'Mar. 2020',
        content: 'Deputy General Manager, Group Management Strategy Office, Corporate Strategy Department of TRIAL Holdings, Inc.',
      },
      {
        date: 'Jun. 2021',
        content: (
          <>
            Standing Corporate Auditor of TRIAL Holdings, Inc. (current position)
            <br />
            Auditor of TRIAL Company, Inc. (current position)
            <br />
            Auditor of Retail AI, Inc. (current position)
          </>
        ),
      },
      {
        date: 'Nov. 2025',
        content: 'Auditor of TRIALS (currently TRIAL Technology, Inc.) (current position)',
      },
    ],
  },
  {
    title: 'Outside Corporate Auditor',
    name: 'Michishige Hashimoto',
    profile: [
      {
        date: 'Nov. 2006',
        content: 'Joined Supreme Court Legal Training and Research Institute',
      },
      {
        date: 'Dec. 2007',
        content: (
          <>
            Registered as Attorney-at-law
            <br />
            Joined Kitahama Partners
          </>
        ),
      },
      {
        date: 'Jan. 2017',
        content:
          'Established Josui Law Office and appointed for Partner (current position)',
      },
      {
        date: 'Jun. 2020',
        content: 'Outside Corporate Auditor of TRIAL Holdings, Inc. (current position)',
      },
      {
        date: 'Nov. 2020',
        content: 'Outside Director of SENTAN Pharma Co., Ltd. (current position)',
      },
      {
        date: 'Dec. 2020',
        content: 'Outside Corporate Auditor of NIPPON INSURE & CO. (current position)',
      },
      {
        date: 'May 2021',
        content: 'Outside Corporate Auditor of CAM Corp. (current position)',
      },
      {
        date: 'Aug. 2021',
        content: 'Outside Director of Institute for Q-shu Pioneers of Space, Inc. (currently QPS Holdings Inc.) (Audit & Supervisory Committee Member, current position)',
      },
      {
        date: 'Jun. 2026',
        content: 'Auditor of Delta-Fly Pharma, Inc. (current position)',
      },
    ],
  },
  {
    title: 'Outside Corporate Auditor',
    name: 'Daisuke Usunabe',
    profile: [
      {
        date: 'Dec. 2008',
        content: 'Joined GYOSEI & Co.',
      },
      {
        date: 'Sep. 2012',
        content: 'Registered as Certified Public Accountant',
      },
      {
        date: 'Jun. 2015',
        content: 'Established Usunabe Certified Public Accountant’s Office (current position)',
      },
      {
        date: 'Nov. 2015',
        content: (
          <>
            Registered as Certified Public Tax Accountant
            <br />
            Established Daisuke Usunabe Tax Accountant Office
          </>
        ),
      },
      {
        date: 'Sep. 2021',
        content: 'Outside Corporate Auditor of TRIAL Holdings, Inc. (current position)',
      },
      {
        date: 'Aug. 2022',
        content: 'Joined KIHARA Tax Corporation',
      },
      {
        date: 'Aug. 2024',
        content: 'Partner, KIHARA Tax Corporation (current position)',
      },
    ],
  },
]